import React, { useContext, useMemo } from 'react';
import ConsentCard from './ConsentCard';
import FiuConsentCard from './FiuConsentCard';
import { UserContext } from '../context/UserContext';
import appLogo from '../assets/Apps.svg';

const ConsentList = ({
	consents,
	selectedAccounts,
	onSelectAccount,
	onViewDetails,
	customDetails,
	groupByEntity = false,
}) => {
	const userContext = useContext(UserContext);
	const isFip = userContext.isFip;

	// Group consents by entity when groupByEntity is true
	const groupedConsents = useMemo(() => {
		if (!groupByEntity || isFip) {
			return null;
		}

		const groups = {};
		consents.forEach((consent) => {
			const entityName = consent.consentIntentEntityName;
			if (!groups[entityName]) {
				groups[entityName] = {
					entityName,
					entityLogoUri: consent.entityLogoUri,
					consents: [],
				};
			}
			groups[entityName].consents.push(consent);
		});

		return Object.values(groups);
	}, [consents, groupByEntity, isFip]);

	// Render grouped by entity
	if (groupByEntity && !isFip && groupedConsents) {
		return (
			<div>
				{groupedConsents.map((group, groupIndex) => (
					<div key={groupIndex}>
						{/* Entity Header */}
						<div
							className="d-flex align-items-center"
							style={{
								gap: '8px',
								marginTop:'16px',
								marginBottom:'8px',
							}}
						>
							<img
								src={group.entityLogoUri || appLogo}
								alt={group.entityName}
								style={{
									width: '18px',
									height: '18px',
									borderRadius: '4px',
									objectFit: 'contain',
								}}
								onError={(e) => {
									e.target.src = appLogo;
								}}
							/>
							<span
								className="fw-500"
								style={{
									fontSize: '14px',
									color: '#6C6C6C',
								}}
							>
								{group.entityName}
							</span>
						</div>

						{/* Consents for this entity */}
						{group.consents.map((consent, index) => {
							const commonProps = {
								key: `${groupIndex}-${index}`,
								consent,
								isSelected: selectedAccounts
									.map((elm) => elm?.consentIntentId)
									.includes(consent.consentIntentId),
								onSelect: onSelectAccount,
								onViewDetails,
								customDetails,
								selectedAccounts,
							};

							return <FiuConsentCard {...commonProps} />;
						})}
					</div>
				))}
			</div>
		);
	}

	// Regular rendering (not grouped)
	return (
		<div>
			{consents.map((consent, index) => {
				const commonProps = {
					key: index,
					consent,
					isSelected: selectedAccounts
						.map((elm) => elm?.consentIntentId)
						.includes(consent.consentIntentId),
					onSelect: onSelectAccount,
					onViewDetails,
					customDetails,
					selectedAccounts,
				};

				return isFip ? (
					<ConsentCard {...commonProps} />
				) : (
					<FiuConsentCard {...commonProps} />
				);
			})}
		</div>
	);
};

export default ConsentList;
